'use client';

import { selectConfig } from '@vimond/features/authentication';
import { Amplify } from 'aws-amplify';

Amplify.configure(selectConfig({ appType: 'web' }), { ssr: true });

const AmplifyConfigSetup = () => {
  // This component is used to set up the Amplify configuration
  // It is a placeholder and does not render anything
  return null;
};
export default AmplifyConfigSetup;
